// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Find Us`
};

const el_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Βρείτε μας`
};

const ru_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Как нас найти`
};

const he_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `מצאו אותנו`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const find_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.find_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("find_us", locale)
	if (locale === "en") return en_find_us(inputs)
	if (locale === "el") return el_find_us(inputs)
	if (locale === "ru") return ru_find_us(inputs)
	if (locale === "he") return he_find_us(inputs)
	return "find_us"
};